import { Inject, Injectable } from '@angular/core';
import { mapValues } from '@sama/micro-dash';
import {
  determineMethod,
  determineResultingIndexes,
} from '../../../cross-team-shared/annotation/shared/utils/selection-utils';
import { SubpointEventInfo } from '../../../cross-team-shared/misc-services/events/mouse-event.service';
import {
  arrayToSubpointSelection,
  selectionToArray,
} from '../../../cross-team-shared/misc-utils';
import {
  ShellConnector,
  shellConnectorToken,
} from '../../../team-apis/core/shell-connector';
import { getShapesWithSubpointsForEventTracking } from '../event-utils';
import { Selection } from '../state/abstract-sensor-content-state-2d';
import { AbstractSensorContentStore2D } from '../state/abstract-sensor-content-store-2d';

@Injectable()
export class SubpointSelectionService {
  constructor(
    @Inject(shellConnectorToken)
    protected shellConnector: ShellConnector,
    private store: AbstractSensorContentStore2D,
  ) {}

  modifySubpointSelection(
    eventInfo: SubpointEventInfo,
    setOrToggle: 'set' | 'toggle',
    source: string,
  ) {
    const shapeIndex = eventInfo.shapeStore.state().index;
    const initialSelection = this.store.state().selection;
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    const indexes = selectionToArray(initialSelection[shapeIndex] || {});
    const indexesToModify = [eventInfo.subpointIndex];
    const method = determineMethod(indexes, indexesToModify, setOrToggle);
    if (!method) {
      return;
    }

    // arrayToSubpointSelection will be moved eventually to 2d content team
    const subpointSelection = arrayToSubpointSelection(
      determineResultingIndexes(method, indexes, indexesToModify),
    );
    let resultingSelection = { [shapeIndex]: subpointSelection };
    if (method === 'set') {
      // fix me if you change this code
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
      if (initialSelection[shapeIndex]) {
        resultingSelection = {
          ...mapValues(initialSelection, () => ({})),
          ...resultingSelection,
        };
      }
    } else {
      resultingSelection = { ...initialSelection, ...resultingSelection };
    }
    this.setSubpointSelection(resultingSelection, method, source);
  }

  clearSubpointSelection() {
    this.store('selection').set(
      mapValues(this.store.state().selection, () => ({})),
    );
  }

  setSubpointSelectionWithoutTracking(selection: Selection) {
    this.store.assign({ selection });
  }

  private setSubpointSelection(
    resultingSelection: Selection,
    method: 'add' | 'remove' | 'set',
    source?: string,
  ) {
    this.setSubpointSelectionWithoutTracking(resultingSelection);
    this.shellConnector.trackEvent({
      id: 'change_subpoint_selection',
      bucket: 'adjustment',
      method,
      source,
      resulting_selection: getShapesWithSubpointsForEventTracking(
        this.store.state().shapes,
        resultingSelection,
      ),
    });
  }
}
